import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import ReviewsTable from "./ReviewsTable";

const PENDING_FILTERS = [
  { key: "pending", label: "Pending" },
  { key: "overdue", label: "Overdue" },
  { key: "all", label: "All" },
];
const COMPLETED_FILTERS = [
  { key: "completed", label: "All Completed" },
  { key: "approved", label: "Approved" },
  { key: "rejected", label: "Rejected" },
];

export default function ReviewerReviews({ mode }) {
  const filters = mode === "completed" ? COMPLETED_FILTERS : PENDING_FILTERS;
  const [status, setStatus] = useState(filters[0].key);
  const [q, setQ] = useState("");
  const [reviews, setReviews] = useState([]);

  const load = useCallback(() => {
    api.get(`/technical-reviewer/reviews?status=${status}&q=${encodeURIComponent(q)}`)
      .then((r) => setReviews(r.data.reviews))
      .catch(() => toast.error("Failed to load reviews"));
  }, [status, q]);
  useEffect(() => { const t = setTimeout(load, 200); return () => clearTimeout(t); }, [load]);

  return (
    <div data-testid={`reviewer-${mode}-page`} className="space-y-4">
      <div>
        <h1 className="font-heading text-2xl font-semibold tracking-tight">{mode === "completed" ? "Completed Reviews" : "Pending Reviews"}</h1>
        <p className="text-sm text-muted-foreground">{reviews.length} review{reviews.length === 1 ? "" : "s"}</p>
      </div>
      <div className="flex flex-wrap items-center gap-3">
        <div className="flex gap-1 rounded-lg border bg-white p-1" data-testid="review-filter-chips">
          {filters.map((f) => (
            <button key={f.key} data-testid={`filter-${f.key}`} onClick={() => setStatus(f.key)}
              className={`rounded-md px-3 py-1.5 text-xs font-medium transition-colors ${status === f.key ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-100"}`}>
              {f.label}
            </button>
          ))}
        </div>
        <div className="relative flex-1 md:max-w-xs">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
          <Input data-testid="review-search" className="pl-9" placeholder="Search event, seller, material…" value={q} onChange={(e) => setQ(e.target.value)} />
        </div>
      </div>
      <ReviewsTable reviews={reviews} showDecision={mode === "completed"} />
    </div>
  );
}
